// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"573":"219d0e20cecd5796","2233":"033e1bdd9782bbdd","3761":"32c393e0322d4758","5846":"6833fa3c8a33eab3"}[chunkId] + ".js";
};